import React, { useEffect, useState } from "react";
import { CustomHeader } from "../../../components/headers/CustomHeader";
import {
  Button,
  CardBody,
  IconButton,
  Input,
  Spinner,
  Typography,
} from "@material-tailwind/react";
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { GETALLRISKCLASS } from "../../../GraphQl/queries";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { DEFAULTPRIMARYCOLOR } from "../../../util";
import { UserType } from "../../../types/user";

type RiskType = {
  name: string;
  id: string;
};

const RiskClassView = () => {
  const [user, setUser] = useState<any>();
  const [searchText, setSearchText] = useState("");
  const [activePage, setActivePage] = useState(1);
  const history = useHistory();
  const PAGE_SIZE = 20;

  const { data, loading, refetch } = useQuery<{
    risk_class: RiskType[];
  }>(GETALLRISKCLASS);

  const handleSearch = (e: any) => {
    setSearchText(e.target.value);
    setActivePage(1);
  };

  const filterData = (item: RiskType) => {
    const isTextMatch = item?.name
      ?.toLowerCase()
      ?.includes(searchText?.toLowerCase());
    return isTextMatch;
  };

  // Filtered and paginated data for the current page
  const paginatedData = data?.risk_class
    ?.filter(filterData)
    .slice((activePage - 1) * PAGE_SIZE, activePage * PAGE_SIZE);

  const nextPage = () => {
    if (
      (activePage - 1) * PAGE_SIZE <
      (data?.risk_class?.filter(filterData).length || 0)
    ) {
      setActivePage(activePage + 1);
    }
  };

  const prevPage = () => {
    if (activePage > 1) {
      setActivePage(activePage - 1);
    }
  };


  const userData = localStorage.getItem("user");
  const [colors, setColors] = useState<string[]>();

  useEffect(() => {
    if (userData) {
      const data: UserType = JSON.parse(userData);

      setColors(data.colors);
    }
  }, []);

  return (
    <>
      <CustomHeader title="Risk Classes" />

      <div className="mt-10">
        <div className="w-full mt-6 ">
          <div className="flex flex-col md:flex-row lg:flex-row gap-2 items-center justify-between bg-white p-3 rounded-lg">
            <div className="flex flex-col md:flex-row lg:flex-row gap-3  w-full">
              <div className="w-full mr-3">
                <Input
                  crossOrigin="anonymous"
                  label="Search"
                  value={searchText}
                  onChange={handleSearch}
                  icon={<i className="fas fa-search text-base"></i>}
                />
              </div>
            </div>
          </div>
        </div>

        <CardBody className="mt-6 shadow-sm overflow-x-scroll  px-0 py-0  rounded-3xl">
          <div className="bg-black pt-5">
            <Typography
              variant="h6"
              style={{
                color:
                  colors?.length! > 1
                    ? `${colors![0]?.toLowerCase()}`
                    : `${DEFAULTPRIMARYCOLOR}`,
              }}
              className="px-4 pb-4 font-bold leading-none opacity-70 capitalize"
            >
              List of Risk class
            </Typography>
          </div>
          <table className=" bg-white w-full min-w-max table-auto">
            <thead className="">
              <tr>
                {["No.", "Risk class", "Description", ""].map((head) => (
                  <th
                    key={head}
                    className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                  >
                    <Typography
                      color="black"
                      className="font-normal text-sm text-black leading-none opacity-70 capitalize"
                    >
                      {head}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData?.map((item, index: number) => {
                const isLast = index === paginatedData?.length - 1;
                const classes = isLast
                  ? "py-3 px-2  text-center"
                  : "py-3 px-2 border-b border-blue-gray-50 text-center";

                return (
                  <tr
                    key={item?.name + index.toString()}
                    className="py-3 hover:bg-gray-100 transition-all hover:cursor-pointer"
                  >
                    <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs capitalize "
                      >
                        {index}
                      </Typography>
                    </td>

                    <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs capitalize "
                      >
                        {item?.name}
                      </Typography>
                    </td>

                    <td className={classes}>
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-normal text-xs capitalize"
                      >
                        ---
                      </Typography>
                    </td>
                    <td className={classes}>
                      <div className="flex flex-row items-center gap-x-2">
                        <Button
                          onClick={() => {
                            localStorage.setItem(
                              "risk",
                              JSON.stringify({
                                id: item?.id,
                                name: item?.name,
                              })
                            );
                            history.push("/dashboard/setup/manage-riskclass");
                            window.location.reload();
                          }}
                          size="sm"
                          color="teal"
                          className="text-xs font-normal capitalize bg-brand-teal"
                        >
                          Manage risk class
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </CardBody>

        {loading && (
          <div className="mt-10 flex items-center justify-center">
            <Spinner className="w-1o h-10" />
          </div>
        )}

        {!paginatedData && !loading && (
          <div className="mt-10 flex text-white items-center justify-center">
            <Typography variant="h6">No data found</Typography>
          </div>
        )}

        {/* Paginator */}
        {paginatedData && (
          <div className="my-10 flex items-center justify-center">
            <div className="flex items-center gap-8">
              <IconButton
                size="sm"
                variant="filled"
                onClick={prevPage}
                disabled={activePage === 1}
              >
                <AiOutlineArrowLeft strokeWidth={2} className="h-4 w-4" />
              </IconButton>
              <Typography color="white" className="font-normal">
                Page <strong className="text-white">{activePage}</strong> of{" "}
                <strong className="text-white">
                  {Math.ceil(
                    (data?.risk_class?.filter(filterData).length || 0) /
                      PAGE_SIZE
                  )}
                </strong>
              </Typography>
              <IconButton
                size="sm"
                variant="filled"
                onClick={nextPage}
                disabled={
                  activePage ===
                  Math.ceil(
                    (data?.risk_class?.filter(filterData).length || 0) /
                      PAGE_SIZE
                  )
                }
              >
                <AiOutlineArrowRight strokeWidth={2} className="h-4 w-4" />
              </IconButton>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default RiskClassView;
